module.exports = __webpack_public_path__ + "img/cpsjc.54fd2f19.png";